var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37393 6.81711L7.90889 13.6217C8.11988 14.5589 9.04886 15.1965 10.0648 15.1017L16.8806 14.4612C17.7206 14.3823 18.4166 13.817 18.6216 13.0479L19.9696 7.98439C20.1276 7.39089 19.6506 6.81711 18.9996 6.81711H6.37393ZM6.37393 6.81711L5.72395 3.99988H4",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3416 17.1984C16.5219 17.1984 15.8564 17.8252 15.8645 18.5972C15.8564 19.3731 16.5259 19.9999 17.3456 19.9999C18.1653 19.9999 18.8308 19.3731 18.8308 18.601C18.8308 17.8252 18.1653 17.1984 17.3416 17.1984Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11914 17.1984C8.29947 17.1984 7.63399 17.8252 7.6421 18.5972C7.63399 19.3731 8.30352 19.9999 9.1232 19.9999C9.94288 19.9999 10.6084 19.3731 10.6084 18.601C10.6084 17.8252 9.94287 17.1984 9.11914 17.1984Z",
    fill: "white"
  })));
};

export default SvgBasket;